(() => {
  const init = () => {
    const sections = document.querySelectorAll('.kubota-statement');
    if (!sections.length) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
      const blocks = section.querySelectorAll(':scope > .ks-block, :scope > .kubota-statement__inner > .ks-block');
      blocks.forEach((el, i) => el.style.setProperty('--i', i));

      if (section.dataset.entrance === 'word-fade') {
        section.querySelectorAll('.ks-p, .ks-html').forEach(splitWords);
      }

      if (reduce) {
        section.classList.add('ks-in-view');
        return;
      }

      // Fire when section's top crosses 80% of viewport (= 20% from bottom).
      // rootMargin bottom -20% shrinks the observer viewport; threshold 0
      // means entry triggers as soon as any pixel enters the shrunk root.
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.classList.add('ks-in-view');
          io.unobserve(section);
        });
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      io.observe(section);
    });
  };

  const splitWords = (root) => {
    let wordIndex = 0;
    const walk = (node) => {
      if (node.nodeType === 3) {
        const frag = document.createDocumentFragment();
        const parts = node.textContent.split(/(\s+)/);
        parts.forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            const span = document.createElement('span');
            span.className = 'ks-word';
            span.style.setProperty('--i', wordIndex++);
            span.textContent = part;
            frag.appendChild(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && !node.matches('script, style')) {
        Array.from(node.childNodes).forEach(walk);
      }
    };
    walk(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
